// import { Notyf } from 'notyf'
// import 'notyf/notyf.min.css' // for React and Vue
// const notyf = new Notyf({
//     duration: 8000,
// });

const Methods = {
    
    watch:{

    },

    methods: {

    },

}

export default Methods